

import React, {useState, useEffect} from 'react';
//import { VisDiv, InsertPhotoSanity} from '../../components';
//import {  errorAlert, keyId, resizeBase64, fromBase64ToSanity } from '../../lib/utils';
import { errorAlert, resizeBase64 } from '../../utils/utils';
import { CgProfile } from 'react-icons/cg';
//import { useUploadPhoto } from '../../hooks/mutations';
import { IoMdImages } from "react-icons/io";
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv';
import InsertPhoto from './InsertPhoto';
import SquareCropPhoto from './SquareCropPhoto';
import { dT } from '../Translation';
import { useStateContext } from '../../context/StateContext';


export const ProfilePicture = ({reset, setReset=()=>{}, doc, setDoc, size=176, profile = true}) => {


    const {apiUrl, language} = useStateContext(); 
    const [photo, setPhoto] = useState(undefined);
    const iconSize  = {width:`${size}px`, height:`${size}px`}

    useEffect(()=>{
        if(reset){
            setPhoto(undefined)
            setReset(false)
        }
    },[reset])

    const savePhoto = (data) => {
        try {
            process.env.NODE_ENV === "development" && console.log("NEW PIC", {
                dataType: typeof data,
                hasBase64: !!data?.base64,
                base64Type: typeof data?.base64,
                base64Length: data?.base64?.length,
                hasFile: !!data?.file,
                fileType: typeof data?.file,
                fileSize: data?.file?.size,
                imageType: data?.file?.type
            });
            
            // Ensure data has the expected structure
            if (!data || typeof data !== 'object' || !data.base64 || typeof data.base64 !== 'string') {
                console.error('Invalid data structure in savePhoto:', data);
                errorAlert(dT({en:"Error, Invalid data structure", it:"Errore, struttura dati errata"}, language))
                return;
            }

            
            setPhoto(data);
            setDoc({...doc, photoFile: data});
            
            process.env.NODE_ENV === "development" && console.log("Photo cropped successfully");
        } catch (error) {
            console.error('Error in savePhoto:', error);
        }
    }
    //`https://remind-public.s3.eu-north-1.amazonaws.com/images/${x?.imageName}.png`
    const photoUrl = doc?.profilePictureUrl || doc?.photoUrl || doc?.imageSource

    return (
    <div>
        <div style={{marginTop:"20px", marginBottom:"20px"}}>
            {/* Use !!photo?.base64 to ensure we're passing a boolean to rules */}
            <VisDiv rules={[!!photo?.base64]}>
                {photo?.base64 && typeof photo.base64 === 'string' && (
                    <img 
                        style={{...iconSize}} 
                        className={profile ? 'profile-icon' : undefined} 
                        src={photo.base64} 
                        alt="Profile"
                    />
                )}
            </VisDiv>
            <VisDiv rules={[!photo?.base64, !!photoUrl]}>
                {photoUrl && typeof photoUrl === 'string' && (
                    <img 
                        style={{...iconSize}} 
                        className={profile ? 'profile-icon' : undefined} 
                        src={photoUrl} 
                        alt="Profile"
                    />
                )}
            </VisDiv>
            <VisDiv rules={[!!profile, !photo, !photoUrl]}>
                <CgProfile style={{...iconSize}} className={profile ? 'profile-icon' : undefined} />
            </VisDiv>
            <VisDiv rules={[!profile, !photo, !photoUrl]}>
                {/* <IoMdImages style={{...iconSize}} className={profile ? 'profile-icon' : undefined} /> */}
                <img 
                    style={{...iconSize}} 
                    className={profile ? 'profile-icon' : undefined} 
                    src={"/homePictures/imagePlaceholder.jpg"} 
                    alt="imagePlaceholder"
                />
                
            </VisDiv>
        </div>
        <VisDiv rules={[true]}>
            <SquareCropPhoto saveFn={savePhoto}/>
        </VisDiv>
    </div>
    )
}

export default ProfilePicture
